import { computed } from 'vue'

import { Ability, Subject } from '../../sites/models/sitePermission'

import { useSiteContext } from '../../sites/composables/useSiteContext'

export function useHasPermission() {
  const {
    site,
    permissions,
  } = useSiteContext()

  const can = (ability: Ability, subject: Subject) => {
    return permissions.value.some((permission) => {
      return permission.ability === ability && permission.subject === subject
    })
  }

  const canCreateBuildings = computed(
    () => site.value.permissions.buildings.canCreate ?? false,
  )
  const canCreateGroups = computed(
    () => site.value.permissions.groups.canCreate ?? false,
  )
  const canCreateReasons = computed(
    () => site.value.permissions.reasons.canCreate ?? false,
  )
  const canCreateSkills = computed(
    () => site.value.permissions.skills.canCreate ?? false,
  )
  const canManageShifts = computed(
    () => site.value.permissions.shifts.canManage ?? false,
  )

  return {
    can,
    canCreateBuildings,
    canCreateGroups,
    canCreateReasons,
    canCreateSkills,
    canManageShifts,
  }
}
